module.exports = __webpack_public_path__ + "img/101.7b112921.png";